import { DestroyRef, Directive, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params } from '@angular/router';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { Customer, CustomerBaseData, UserDataModel } from '@zero/shared/util-models';
import { DataService, UserDataService, UserMessagesHolderService } from '@zero/shared/util-web-app-services';
import { environment } from 'environments/environment';
import { filter } from 'rxjs/operators';

@Directive()
export abstract class BaseComponent {
  @Input() public showMe = false;

  public editMode = false;
  public currentUser: UserDataModel;
  public currentCustomer: Customer;
  public customerBaseData: CustomerBaseData;
  public section?:
    | 'konto-depot'
    | 'krypto-wallet'
    | 'tax'
    | 'user-contact-data'
    | 'depot'
    | 'security'
    | 'notification-administration'
    | 'kunden-werben';
  public readonly ENV = environment;

  protected readonly userService = inject(UserDataService);
  protected readonly messageService = inject(UserMessagesHolderService);
  public readonly dataService = inject(DataService);
  protected readonly route = inject(ActivatedRoute);
  protected readonly destroyRef = inject(DestroyRef);
  protected readonly customerStateFacade = inject(CustomerStateFacade);

  constructor() {
    this.currentUser = undefined;
    this.customerBaseData = new CustomerBaseData();
    this.customerStateFacade.customerBaseData$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (value) => {
        this.customerBaseData = value;
      },
    });
    this.userService
      .loadContactData$(false)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (result) {
          this.currentUser = result;
        }
      });
    this.dataService.selectedCustomerChanged
      .pipe(
        filter((newCust) => !!newCust),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.currentCustomer = this.dataService.getSelectedCustomerItem();
      });
    this.route.queryParams.subscribe((params: Params) => {
      this.section = params['section'];
    });
  }
}
